import * as AT from "src/core/lists/store/lists.constants";
import { ICurrentList } from "src/core/lists/store/lists.reducer";
import { IProduct } from "src/core/products/api/products.api";

import { IList } from "../api/lists.api";

export type ListActions = ISetCurrentList | IUpdateCustomerReference | ISetLists | IUpdateListRow | IUpdateListLine | IPurgeLists;

interface IUpdateListLine {
  type: AT.UPDATE_LIST_LINE;
  product: IProduct;
  newQuantity: number;
}

export const updateListLine = (product: IProduct, newQuentity: number): IUpdateListLine => {
  return {
    type: AT.UPDATE_LIST_LINE,
    product,
    newQuantity: newQuentity
  };
};

interface ISetCurrentList {
  type: AT.SET_CURRENT_LIST;
  list: ICurrentList | null;
}

export const setCurrentList = (list: ICurrentList | null): ISetCurrentList => {
  return {
    type: AT.SET_CURRENT_LIST,
    list
  };
};

interface IUpdateCustomerReference {
  type: AT.UPDATE_CUSTOMER_REFERENCE;
  reference: string;
}

export const updateCustomerReference = (reference: string): IUpdateCustomerReference => {
  return {
    type: AT.UPDATE_CUSTOMER_REFERENCE,
    reference
  };
};

interface ISetLists {
  type: AT.SET_LISTS;
  lists: IList[];
}

export const setLists = (lists: IList[]): ISetLists => {
  return {
    type: AT.SET_LISTS,
    lists
  };
};

interface IUpdateListRow {
  type: AT.UPDATE_LIST_ROW;
  list: IList;
}

export const updateListRow = (list: IList): IUpdateListRow => {
  return {
    type: AT.UPDATE_LIST_ROW,
    list
  };
};

interface IPurgeLists {
  type: AT.PURGE_LISTS;
}

export const purgeLists = (): IPurgeLists => {
  return { type: AT.PURGE_LISTS };
};
